/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Grading } from './grading';

export type CourseModuleGrading = Grading | null;
